/* This will be a dynamic person viewer. 
    The person displayed is based on the id indicated in the url path
    The person data is passed on to the children compoents (headerblock, description, etc)
        this allows all information about each person to be dynamically displayed.
*/

import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import HeaderBlock from '../Components/Members/HeaderBlock';
import Description from '../Components/Members/Description';
import PersonSubNav from '../Components/Members/PersonSubNav';
import MemberAssociations from '../Components/Members/MemberAssociations';
import Media from '../Components/Members/Media';
import Family from '../Components/Family';
import { Link } from "react-router-dom";
import { find } from 'lodash';
import { generateClient } from 'aws-amplify/data';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Person(props) {
  const client = generateClient();
  const [member, setMember] = useState({});
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    setOpen(true)
    getMember();
  }, [props.match.params.id]);

  const getMember = async () => {
    try {
      const { data: memberData } = await client.models.Member.get({
        id: props.match.params.id
      }, {
        selectionSet: ['id', 'name.*', 'profileKey', 'phone', 'email', 'sex', 'address', 'abstract', 'description', 'birthdate', 'media.*', 'associations1.member1.*', 'associations1.member2.*', 'associations1.*', 'associations2.member1.*', 'associations2.member2.*', 'associations2.*']
      });
      console.log(memberData);
      setMember(memberData)
      setOpen(false)
    } catch (error) {
      console.error('Error fetching member:', error);
      setOpen(false)
    }
  }

  if (!member || !member.id) return null;

  return <div className="page">
    <PersonSubNav member={member} />
    <HeaderBlock member={member} />
    <MemberAssociations member={member} />
    <Description member={member} />

    <Media member={member} />
    <Backdrop className={classes.backdrop} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  </div>;


}



export default withRouter(Person)